const features = [
  {
    icon: 'ri-flashlight-line',
    title: '极速浏览',
    description: '自研Velo渲染引擎，页面加载速度提升40%，JavaScript执行效率提升28%，为您带来毫秒级响应体验。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全防护',
    description: '智能反钓鱼系统、恶意网站拦截、下载安全扫描，多层防护机制全方位守护您的上网安全。',
  },
  {
    icon: 'ri-eye-off-line',
    title: '隐私保护',
    description: '无痕浏览模式、防指纹追踪、第三方Cookie自动隔离，您的上网数据只属于您自己。',
  },
  {
    icon: 'ri-forbid-line',
    title: '广告拦截',
    description: '内置智能广告拦截引擎，自动屏蔽弹窗、横幅和视频广告，纯净浏览体验一览无余。',
  },
  {
    icon: 'ri-stack-line',
    title: '智能标签',
    description: '自动分组、一键休眠、拖拽管理，即使同时打开50+标签页也流畅如初。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '跨设备同步',
    description: '书签、密码、历史记录实时云端同步，电脑手机无缝切换，端到端加密保障数据安全。',
  },
];

export default function FeatureSection() {
  return (
    <section id="features" className="py-20 md:py-28 bg-background-50">
      <div className="px-4 md:px-6 max-w-6xl mx-auto">
        <div className="text-center mb-14">
          <span className="inline-block px-3.5 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold font-label mb-4">
            核心功能
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-4">
            为什么选择91浏览器
          </h2>
          <p className="text-foreground-600 max-w-xl mx-auto text-base leading-relaxed">
            每一个功能都经过精心打磨，只为让您获得最好的浏览体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="group p-6 rounded-xl bg-background-100/70 hover:bg-background-100 border border-background-200/60 transition-all duration-300 cursor-pointer"
            >
              <div className="w-11 h-11 rounded-lg bg-primary-100 flex items-center justify-center mb-4 group-hover:bg-primary-200 transition-colors">
                <i className={`${feature.icon} text-primary-600 text-xl w-5 h-5 flex items-center justify-center`}></i>
              </div>
              <h3 className="font-heading font-semibold text-foreground-900 mb-2 text-base">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}